import { render, staticRenderFns } from "./HeaderNotice.vue?vue&type=template&id=1c1467d0&scoped=true&"
import script from "./HeaderNotice.vue?vue&type=script&lang=js&"
export * from "./HeaderNotice.vue?vue&type=script&lang=js&"
import style0 from "./HeaderNotice.vue?vue&type=style&index=0&lang=css&"
import style1 from "./HeaderNotice.vue?vue&type=style&index=1&id=1c1467d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1467d0",
  null
  
)

export default component.exports